import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { AppEnvNotInjectedError, getAppEnv } from '@/lib/env'
import { Root } from './Root'

try {
  const appEnv = getAppEnv()

  if (appEnv.environment === 'prod') {
    Sentry.init({
      dsn: 'https://328eff6a72e541fcba4ecdad77a7f233@o373343.ingest.us.sentry.io/5530667',
      release: import.meta.env.VITE_SENTRY_RELEASE,
      environment: appEnv.environment,
      dataCollection: { userInfo: false },
    })

    Sentry.setTag('serviceId', 'link-builder')

    if (appEnv.dataRegion) {
      Sentry.setTag('dataRegion', appEnv.dataRegion)
    }
  }
} catch (e) {
  if (!(e instanceof AppEnvNotInjectedError)) throw e
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </StrictMode>,
)
